import { render, staticRenderFns } from "./ViolinBoxPlot.vue?vue&type=template&id=6363a052&scoped=true"
import script from "./ViolinBoxPlot.vue?vue&type=script&lang=js"
export * from "./ViolinBoxPlot.vue?vue&type=script&lang=js"
import style0 from "./ViolinBoxPlot.vue?vue&type=style&index=0&id=6363a052&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6363a052",
  null
  
)

export default component.exports